/**
 * AIの応答待ち中にチャットメッセージ欄の末尾に表示する「入力中」インジケーター。
 * ドットアニメーションに加え、progressイベントで届いた処理内容ラベルを併記できる。
 *
 * @param {Object} props
 * @param {string} [props.label] - 表示中の処理内容（例: "文書を検索しています…"）。未指定時はドットのみ表示。
 */
const TypingIndicator = ({ label }) => (
  <div className="message ai">
    <div className="message-sender">
      <span className="ai-badge">AI</span>
    </div>
    <div className="typing-indicator">
      <div className="typing-dot" />
      <div className="typing-dot" />
      <div className="typing-dot" />
      {label && <span className="typing-indicator-label">{label}</span>}
    </div>
  </div>
);

export default TypingIndicator;
